"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var csod = require("player-core");
var constants = require("../../shared/code/Constants");
var moment = require("moment");
var PsqHelper_1 = require("../../shared/code/PsqHelper");
function viewSF() {
    var _this = this;
    var requiredQuestion = function (props) { return (PsqHelper_1.PsqHelper.getLabel(props.question) + ' <br> <br> '); };
    var getStateByProps = function (props) { return ({
        displayValue: (props.question.options[0].value) ? new Date(props.question.options[0].value.replace(/-/g, '\/')) : '',
        value: props.question.options[0].value,
        errorMessage: props.errorMessage,
        constants: constants,
        formattedQuestion: requiredQuestion(props),
        invalidDateErrorMessage: csod.locales.get('Please enter a valid date.', 'Please enter a valid date.')
    }); };
    return {
        constructor: function (props) {
            _this.state = getStateByProps(props);
        },
        willReceiveProps: function (nextProps) {
            if (nextProps.question.questionId != _this.props.question.questionId) {
                _this.setState(getStateByProps(nextProps));
            }
            if (nextProps.errorMessage && !_this.state.value) {
                _this.setState({ errorMessage: nextProps.errorMessage });
            }
        },
        events: {
            onChange: function (date, value, isValid) {
                var result = (value || '').trim() == '' ? null : '';
                if (date != null) {
                    if (date < new Date(1753, 1, 1)) {
                        date = null;
                        result = '';
                    }
                    else {
                        result = moment(date).format('YYYY-MM-DD');
                    }
                }
                _this.props.onChange(result, _this.props.question.questionId, _this.props.question.options[0].responseId);
                var errorMessage = isValid ? null : _this.state.invalidDateErrorMessage;
                _this.setState({ value: date, errorMessage: errorMessage });
            }
        }
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/.tmp/PSQDate/ViewSF.js
// module id = 762
// module chunks = 0